<div class="host-ctrip-price-form">
  <div class="extra-body">
    <div class="table-row">
      <div class="col-1"></div>
      <div class="col-2">
        {{ "ctrip.commission" | translate }}
        <!-- 佣金 -->
      </div>
      <div class="col-3"></div>
      <div class="col-4">
        {{ "ctrip.reserve_price" | translate }}
        <!-- 底价 -->
      </div>
      <div class="col-5">
        {{ "ctrip.sale_price" | translate }}
        <!-- 卖价 -->
      </div>
    </div>
    <div class="table-row">
      <!-- <div class="col-1">{{ paymentType === 0 ? '预付' : '现付' }}</div> -->
      <div class="col-1">
        {{ (paymentType === 0 ? "ctrip.prepaid" : "ctrip.by_cash") | translate }}
      </div>
      <div class="col-2">
        <host-input-with-error
          [showError]="displayErrorText && exceedCommissionLimit()"
          [errorText]="'佣金率不可低于10%'">
          <input class="input" type="number" nz-input [(ngModel)]="commission" (ngModelChange)="onCommissionChange()" />
        </host-input-with-error>
      </div>
      <div class="col-3">%</div>
      <div class="col-4">
        <input type="text" class="input" nz-input [(ngModel)]="reservePrice" (ngModelChange)="onReservePriceChange()" />
      </div>
      <div class="col-5">
        <input class="input" type="number" step="0.00001" nz-input disabled [(ngModel)]="salePrice" />
      </div>
    </div>
  </div>
  <div class="extra-footer">
    <div class="left" (click)="displayCtripPriceTipModal()">
      <i nz-icon nzType="question-circle" nzTheme="outline"></i>
      <span>
        {{ "ctrip.how_to_set_up" | translate }}
        <!-- 如何设置？ -->
      </span>
    </div>
    <div class="right">
      <button nz-button nzSize="small" (click)="clear()">
        {{ "word.close" | translate }}
        <!-- 关闭 -->
      </button>
      <button nz-button nzType="primary" nzSize="small" (click)="confirm()">
        {{ "word.save" | translate }}
        <!-- 保存 -->
      </button>
    </div>
  </div>
</div>

<ng-template #ctripPriceTipModal>
  <div class="ctrip-price-tip-modal">
    <p class="item">
      {{ "ctrip.tip_1" | translate }}
      <!-- 1、预付和现付均通过卖价设置。 -->
    </p>
    <p class="item">
      {{ "ctrip.tip_2" | translate }}
      <!-- 2、请勿低于最低佣金，避免改价失败。 -->
    </p>
    <p class="item">
      {{ "ctrip.tip_3" | translate }}
      <!-- 3、如无现付，请忽略现付的设置，不会影响其他价格。 -->
    </p>

    <p class="service">
      {{ "word.has_question" | translate }}
      <!-- 如有问题，请 -->
      <span class="link" (click)="displayCustomerServiceModal()">
        {{ "word.contact_3" | translate }}
        <!-- 联系客服 -->
      </span>
    </p>
  </div>
</ng-template>
